export const SessionKeyEnum = {
  AppKey: "AppKey",
  EncryptedMode: "EncryptedMode",
  ProfileId: "ProfileId",
  ProfileStatusType: "ProfileStatusType",
  HolderType: "HolderType",
  CurrentEntityType: "CurrentEntityType",
  CurrentWidget: "CurrentWidget",
  CurrentWorkflow: "CurrentWorkflow",
  KycApplicationId: "KycApplicationId",
  Id: "Id",
  isAdmin: "isAdmin",
};
